(function ($, Cobalt, undefined) {
    Cobalt.AdminPanel = {
        adminGetSubnamespacesRoute: null,
        adminGetRouteNamesRoute: null,

        initialize: function () {
            Cobalt.AdminPanel.initializeCacheManager();

            Cobalt.runOnHtmlInsert(function () {
                Cobalt.AdminPanel.initializeControllerActionForm();
            });

            Cobalt.AdminPanel.initializeSiteSearch();
            Cobalt.AdminPanel.initializeAdvertisingContentForm();
            Cobalt.AdminPanel.initializeSocialPlatforms();
            Cobalt.AdminPanel.initializeUserContentManager();
        },
        initializeUserContentManager: function () {

            $("form.j-user-content-moderation").ajaxForm(
            {
                success: function (responseText, statusText, xhr, form) {
                    var tr = form.parents("tr");
                    tr.remove();
                    Cobalt.Core.resetBulkModerationCookie("userContentFolderBulkModeration");
                    Cobalt.Core.resetBulkModerationCookie("userContentPostBulkModeration");
                },
                error: function (data) {
                    alert("An error occurred while trying to moderate this folder.");
                }
            });

        },
        initializeSocialPlatforms: function () {
            $("div.social-platform").each(function () {

                var form = $(this).find("form");
                var link = $(this).find("div.social-link");
                $.log(form);
                form.ajaxForm(
                    {
                        type: 'post',
                        cache: false,
                        success: function (data) {
                            $.log(data);
                            if (data.LinkingAvailable) {
                                link.css("visibility", "visible");
                            }
                            else {
                                link.css("visibility", "hidden");
                            }
                        }
                    }
                );

                var inputs = form.find("input").change(function () {
                    form.submit();
                });
            });
        },
        initializeAdvertisingContentForm: function () {
            Cobalt.runOnHtmlInsert(function ($parent) {
                var isEnabledField = $('#field-is-enabled');
                var contentField = $('#form-field-content');
                var secureField = $('#form-field-secure-content');
                var isEnabled = true;
                if (isEnabledField.attr("checked") != "checked") {
                    isEnabled = false;
                    contentField.hide();
                    secureField.hide();
                }
                isEnabledField.change(function () {
                    if (isEnabled) {
                        isEnabled = false;
                        contentField.hide();
                        secureField.hide();
                    }
                    else {
                        isEnabled = true;
                        contentField.show();
                        secureField.show();
                    }
                });
            });
        },

        initializeSiteSearch: function () {
            // Site search
            var siteSearch = $("#field-siteSearch");
            if (siteSearch.length == 0) {
                return;
            }
            var siteIDTextBox = $("#field-site");

            if (Cobalt.Routes.Instance.CPAjaxAutoCompleteSiteName != undefined) {
                siteSearch.autocomplete(Cobalt.Routes.Instance.CPAjaxAutoCompleteSiteName(), {
                    minChars: 3,
                    scroll: false
                }).result(function (evt, data, formatted) {
                    siteIDTextBox.val(data[1]);
                });
                siteSearch.blur(function () {
                    if (siteSearch.val() == "") {
                        siteIDTextBox.val("");
                    }
                });

                if (siteIDTextBox.length > 0) {
                    var siteID = siteIDTextBox.val();
                    if (siteID != "") {
                        $.getJSON(Cobalt.Routes.Instance.CPGetNameForSite({ siteID: siteID }), null, function (data) {
                            siteSearch.val(data.Title);
                        });
                    }
                }
            }
        },
        updateControllerActions: function (evt, nameElement, callback) {
            $.log(nameElement);
            var $nameElement = nameElement || $(this);
            var val = $nameElement.val();
            var actionFieldID = $nameElement.attr("data-action-field-id");
            $.log(actionFieldID);
            var $actionElement = $("#" + actionFieldID);
            $.log($actionElement);
            $actionElement = $actionElement.empty().disable();

            if (!val) {
                return;
            }

            $.get('/cp/get-controller-actions/' + val, function (data) {
                $('<option value="">').text('*').appendTo($actionElement);

                if (!!data && data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        var action = data[i];
                        $('<option>').attr('value', action).text(action).appendTo($actionElement);
                    }
                }

                $actionElement.enable();

                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        },

        initializeControllerActionForm: function () {
            $("select.j-controller-name-field").change(Cobalt.AdminPanel.updateControllerActions);

            $('#field-url').change(function () {
                var $field = $(this);

                if ($field.val() === '') {
                    return;
                }

                $.get('/cp/get-route-data?url=' + $(this).val(), function (data) {
                    $('#field-controller-name').val(data.controller);

                    Cobalt.AdminPanel.updateControllerActions(null, $('#field-controller-name'), function () {
                        $('#field-action-name').val(data.action);
                    });
                });
            });
        },

        initializeLocalizationForm: function () {

            //TODO: Could not get tinyMCE to load correctly
            //$('#enable-html').click(function () {
            //    if ($('#enable-html:checked').val() == null) {
            //        if ($('.mce-container').length >= 0) {
            //                $('.mce-tinymce.mce-container.mce-panel').each(function() {
            //                    var id = $(this).attr("id");
            //                    tinymce.remove(id);
            //                });
            //          }
            //    } else {
            //        if ($('.mce-container').length == 0) {
            //                tinyMCE.init({
            //                    selector: "textarea",
            //                    plugins: [
            //                        "advlist autolink lists link image charmap print preview anchor",
            //                        "searchreplace visualblocks code fullscreen",
            //                        "insertdatetime media table contextmenu paste"
            //                    ],
            //                    toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image"
            //                });                     
            //        }
            //    }
            //});

            $('.edit-phrase').focus(function () {
                    $(this).css('height', '200px');
            });



            $("select#field-namespace").change(function () {
                var subNamespaces = $("select#field-subNamespace");

                var nsId = $("select#field-namespace").val();
                if (nsId == '') {
                    $(subNamespaces).attr('disabled', true).html('');
                    return;
                }
                $.ajax({
                    type: "GET",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    url: Cobalt.AdminPanel.adminGetSubnamespacesRoute(nsId),
                    success: function (data) {
                        $("select#field-subNamespace > option + option").remove();
                        if (data.length > 0) {
                            for (var i = 0; i < data.length; i++) {
                                var sns = data[i];
                                if (sns != null) {
                                    subNamespaces.append($("<option>").attr("value", sns.ID).text(sns.Name));
                                }
                            }
                            subNamespaces.removeAttr('disabled');
                        } else {
                            subNamespaces.attr('disabled', true).html('');
                        }
                    }
                });
            });
        },

        initializeCacheManager: function () {
            // Attach a click event to the invalidate buttons
            $(".listing-cache-entry .invalidate-button").each(function () {
                $(this).click(function () {
                    var row = $(this).parent().parent();
                    var cacheKey = escape($(this).attr("data-cache-key"));
                    var url = Cobalt.Routes.Instance.CPCacheManagerInvalidateDataKey();
                    $.ajax({
                        url: url,
                        data: { 'cacheKey': cacheKey },
                        type: "POST",
                        dataType: "html",
                        success: function (data) {
                            row.remove();
                        },
                        error: function () {
                            alert("Unable to remove cache key!");
                        }
                    });
                });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.AdminPanel.js